import { RcTrans } from '@/components/atoms/RcTrans'
import { MarkdownDisplay } from '@/components/molecules/input/MarkdownDisplay'
import { RcButton } from '@/components/molecules/interactive/RcButton'
import { useCommunityTicket } from '@/entity/community/useCommunityTicket'
import { useCompetitionTicket } from '@/entity/competition/useCompetitionTicket'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'

export const CommunityTicketHeader = ({ ticketId }: { ticketId: number }) => {
  const {
    ticket,
    close,
    read: { isValidating }
  } = useCommunityTicket({
    idOrKey: ticketId
  })
  return (
    <TicketHeader ticket={ticket} close={close} isValidating={isValidating} />
  )
}

export const CompetitionTicketHeader = ({ ticketId }: { ticketId: number }) => {
  const {
    ticket,
    close,
    read: { isValidating }
  } = useCompetitionTicket({
    idOrKey: ticketId
  })
  return (
    <TicketHeader ticket={ticket} close={close} isValidating={isValidating} />
  )
}

const TicketHeader = ({
  ticket,
  close,
  isValidating
}: {
  ticket?: { id?: number; description?: string; closed?: boolean }
  close: (id: number) => Promise<any>
  isValidating: any
}) => {
  return (
    <Paper sx={{ borderRadius: 0, p: 3 }}>
      <Grid container direction='row' spacing={2}>
        <Grid item xs={12}>
          <MarkdownDisplay markdown={ticket?.description} paragraph={false} />
        </Grid>
        <Grid item xs textAlign='right'>
          {isValidating ? null : ticket?.closed ? (
            <RcButton disabled variant='outlined' size='small'>
              <RcTrans i18nKey='contact:resolved-button' />
            </RcButton>
          ) : (
            <RcButton onClick={() => close(ticket?.id!)} size='small'>
              <RcTrans i18nKey='contact:mark-as-resolved-button' />
            </RcButton>
          )}
        </Grid>
      </Grid>
    </Paper>
  )
}
